import { LayerType } from "@tuliu/base-map";
import { Ref, ref } from "@vue/composition-api";
import DrawMap from "@/components/BaseMap.vue";
import { LatLngTuple } from "@tuliu/leaflet";
import { useOnSetLocation } from "./useAPPCallJS";
import { storeToRefs } from "pinia";
import { useDrawStore } from "@/store/draw";

// 地图图层相关逻辑
export const useMapLayer = () => {
  const layer = ref<LayerType>(LayerType.defaultSatellite);

  const handleLayerSwitch = () => {
    layer.value =
      layer.value === LayerType.defaultSatellite
        ? LayerType.defaultVector
        : LayerType.defaultSatellite;
  };

  return {
    layer,
    handleLayerSwitch,
  };
};

/**
 * 地图中心点相关
 * @returns
 */
export const useMapCenter = (mapRef: Ref<typeof DrawMap | null>) => {
  const store = useDrawStore();
  const { mapCenter } = storeToRefs(store);
  const mapZoom = ref(18);
  let mapCenterFromApp: LatLngTuple;

  // 定位到绘制图形的中心点
  const handleGotoLandCenter = async () => {
    if (mapRef.value) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (mapRef.value as any).toGraphicCenter();
    }
  };

  // 定位到用户地理位置
  const handleToGeoLocation = () => {
    if (mapCenterFromApp) {
      mapCenter.value = [...mapCenterFromApp];
    }
  };

  // 监听 APP 传递过滤的地理位置经纬度
  // 只有第一次传递过来时直接定位到对应地理位置
  // 之后只记录其值，需要用户手动触发再定位到对应位置
  let isInit = false;
  useOnSetLocation((data: LatLngTuple) => {
    mapCenterFromApp = data;

    if (!isInit) {
      mapCenter.value = mapCenterFromApp;
      isInit = true;
    }
  });

  return {
    mapZoom,
    handleGotoLandCenter,
    handleToGeoLocation,
  };
};
